import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { handleLogout, checkForDomain } from '../../utilities';
import { trackEvent } from 'utilities/mixpanel';

export const useLogout = (startupDetail, userAccess) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  return () => {
    handleLogout({
      dispatch,
      navigate,
      location,
      startupName: startupDetail?.startup_name,
      userName: userAccess?.userName,
    });
  };
};

export const useSidebarAuth = () => {
  const switchStartup = (startupId, startupName) => {
    const domain = checkForDomain();
    Cookies.set('X-ST-ID', startupId, { domain });
    if (window.location.host?.includes('localhost')) {
      Cookies.set('X-ST-ID', startupId);
    }
    trackEvent('Switch Startup Profile', { startup_name: startupName });
    window.location.reload();
  };

  return { switchStartup };
};
